export const DEFAULT_PAGINATION_LIMIT = 25;
export const MAX_PAGINATION_LIMIT = 100;
